import { jsxs as i, jsx as e } from "react/jsx-runtime";
import { useChatbotContext as o } from "../../hooks/useChatbotContext.js";
function a({ buttonText: r = "Restart chat" }) {
  const { chatbot: t, handleRestart: n } = o();
  return /* @__PURE__ */ i("div", { className: "mt-2 flex items-center gap-x-[14px] pl-5 pr-[60px] text-center text-xs text-muted-foreground", children: [
    /* @__PURE__ */ e("div", { className: "flex-grow border-t border-[#A8A5A0]" }),
    /* @__PURE__ */ e(
      "svg",
      {
        width: "15",
        height: "19",
        viewBox: "0 0 15 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ e(
          "path",
          {
            d: "M7.5 3.33337H3.41667L5.51667 0.833374H3.33333L0.541667 4.16671L3.33333 7.50004H5.51667L3.41667 5.00004H7.5C8.65372 5.00004 9.78154 5.34216 10.7408 5.98313C11.7001 6.62411 12.4478 7.53515 12.8893 8.60105C13.3308 9.66696 13.4463 10.8398 13.2212 11.9714C12.9962 13.103 12.4406 14.1424 11.6248 14.9582C10.809 15.774 9.76958 16.3295 8.63803 16.5546C7.50647 16.7797 6.33358 16.6642 5.26768 16.2227C4.20178 15.7812 3.29074 15.0335 2.64976 14.0742C2.00879 13.1149 1.66667 11.9871 1.66667 10.8334H0C0 12.3167 0.439867 13.7668 1.26398 15.0001C2.08809 16.2335 3.25943 17.1948 4.62987 17.7625C6.00032 18.3301 7.50832 18.4787 8.96318 18.1893C10.418 17.8999 11.7544 17.1856 12.8033 16.1367C13.8522 15.0878 14.5665 13.7514 14.8559 12.2966C15.1453 10.8417 14.9968 9.33369 14.4291 7.96325C13.8614 6.5928 12.9001 5.42146 11.6668 4.59735C10.4334 3.77324 8.98336 3.33337 7.5 3.33337Z",
            fill: "#95928E"
          }
        )
      }
    ),
    /* @__PURE__ */ e(
      "button",
      {
        className: "rounded-small text-inherit underline ring-1 ring-transparent ring-offset-2 ring-offset-background transition hover:bg-accent hover:text-accent-foreground focus-visible:outline-none focus-visible:ring-ring",
        onClick: () => {
          t != null && t.id && n();
        },
        children: r
      }
    ),
    /* @__PURE__ */ e("div", { className: "flex-grow border-t border-[#A8A5A0]" })
  ] });
}
export {
  a as InactivityIndicator
};
